const CONSONANT_O = /([b-df-hj-np-tv-z])o$/i; // add es
const CONSONANT_Y = /([b-df-hj-np-tv-z])y$/i; // change y to i and add es
const ES_SUFFIXES = /(?:ss|sh|ch|[sxz])$/i; // add es
const F_FE = /fe?$/i; // change f to ves
const VOWEL_O = /[aeiou]o$/i; // add s
const VOWEL_Y = /([aeiou])y$/i; // add s

/**
 * Format a string to its plural form based on the provided quantity
 *
 * @param {number} quantity A number representing the quantity of items
 * @param {string} singular The singular form of the word
 * @param {string} [plural] The plural form of the word. If not provided, the plural will be deduced using basic English rules
 * @returns The plural form of the word based on the provided quantity
 */
export function formatPlural(quantity: number, singular: string, plural?: string): string {
  const isSingular = quantity === 1;

  if (isSingular) {
    return singular;
  } else if (plural) {
    return plural;
  }

  if (ES_SUFFIXES.test(singular) || CONSONANT_O.test(singular)) {
    return `${singular}es`;
  } else if (CONSONANT_Y.test(singular)) {
    return singular.replace(CONSONANT_Y, '$1ies');
  } else if (VOWEL_Y.test(singular) || VOWEL_O.test(singular)) {
    return `${singular}s`;
  } else if (F_FE.test(singular)) {
    return singular.replace(F_FE, 'ves');
  }

  return `${singular}s`;
}
